import { useContext } from "react";
import NavBarComp from "../../components/navbar/navbar";
import { CartContext } from "../../App";

export interface PrivacyProps {

}

function Privacy(props: PrivacyProps) {
    const cartContext = useContext(CartContext);

    return (
        <div className="privacypolicy">
            <NavBarComp active="privacy" nCart={cartContext.cart ? cartContext.cart.items_count : 0}></NavBarComp>
            <div className="container">
                <div className="row mt-2">
                    <div className="col col-12">
                        <h3>Privacy Policy</h3>
                        <figcaption className="blockquote-footer mt-1"><small>Ultimo aggiornamento: 22/12/2024</small></figcaption>

                        <h5>1. Titolare del Trattamento dei Dati</h5>
                        <p>Il titolare del trattamento dei dati è BELLACOSAFOOD s.r.l.s.,
                            con sede legale in Via Vincenzo Montefusco, n. 14, 84013 Cava de' Tirreni SA,
                            e può essere contattato all'indirizzo email bellacosawinefood@yahoo.com.</p>

                        <h5>2. Tipologia di Dati Raccolti</h5>
                        <p>
                            Per utilizzare il nostro sito non è richiesta alcuna registrazione e non raccogliamo dati personali degli utenti che visitano o acquistano attraverso il nostro sito. Tuttavia, per completare l'ordine, raccogliamo le seguenti informazioni:
                        </p>
                        <ul>
                            <li>
                                Dati necessari per la spedizione dell'ordine (nome, indirizzo di spedizione, eventuale numero di telefono per la consegna)

                            </li>
                            <li>
                                Dati necessari per il pagamento, come ad esempio il numero della carta di credito, tramite i sistemi sicuri di pagamento online (senza che il sito trattenga queste informazioni).
                            </li>
                        </ul>
                        <h5>3. Finalità del Trattamento dei Dati</h5>
                        <p>
                            I dati forniti dagli utenti vengono utilizzati esclusivamente per:
                        </p>
                        <ul>
                            <li>
                                Elaborare e spedire gli ordini;
                            </li>
                            <li>
                                Fornire assistenza post-vendita se necessario.
                            </li>
                        </ul>

                        <h5>4. Base Giuridica del Trattamento</h5>
                        <p>
                            Il trattamento dei dati per la finalità di evasione degli ordini si basa sulla necessità contrattuale di adempiere alla richiesta dell'utente (Art. 6(1)(b) del Regolamento UE 2016/679 - GDPR).
                        </p>
                        <h5>5. Conservazione dei Dati</h5>
                        <p>
                            I dati raccolti vengono conservati solo per il tempo necessario a soddisfare le finalità descritte nella presente Privacy Policy e per gli obblighi legali relativi alla conservazione dei dati contabili.
                        </p>

                        <h5>6. Sicurezza dei Dati</h5>
                        <p>
                            Ci impegniamo a proteggere i dati degli utenti adottando misure di sicurezza adeguate per evitare accessi non autorizzati, divulgazione o modifica dei dati personali.
                        </p>

                        <h5>7. Diritti degli Utenti</h5>
                        <p>
                            Gli utenti possono esercitare i diritti previsti dal GDPR, tra cui:
                        </p>
                        <ul>
                            <li>
                                Accesso ai propri dati;
                            </li>
                            <li>
                                Richiesta di correzione o cancellazione dei dati;
                            </li>
                            <li>
                                Opposizione al trattamento;
                            </li>
                            <li>
                                Richiesta di limitazione del trattamento.
                            </li>
                        </ul>
                        <p>
                            Per esercitare tali diritti, è possibile inviare una richiesta all'indirizzo email bellacosawinefood@yahoo.com.
                        </p>




                        <h3>Cookie Policy</h3>
                        <p>
                            Il nostro sito utilizza solo cookie tecnici, necessari per garantire il funzionamento del sito stesso. Non vengono utilizzati cookie di profilazione né vengono installati cookie di terze parti.
                        </p>

                        <h5>Cosa sono i Cookie?</h5>
                        <p>
                            I cookie sono piccoli file di testo che il sito invia al dispositivo dell'utente durante la navigazione. Servono a rendere la navigazione più efficiente e a migliorare l'esperienza d'uso.
                        </p>

                        <h5>Tipologie di Cookie Utilizzati</h5>
                        <p>
                            Cookie Tecnici: Questi cookie sono essenziali per il corretto funzionamento del sito e permettono di gestire il carrello e il processo di checkout. Essendo cookie strettamente necessari, non richiedono il consenso preventivo dell'utente per essere installati.
                        </p>
                        <h5> Gestione dei Cookie</h5>
                        <p>
                            Gli utenti possono configurare il proprio browser per rifiutare i cookie o per essere avvisati ogni volta che un cookie viene inviato. Tuttavia, il blocco dei cookie tecnici potrebbe compromettere la funzionalità del sito, in particolare per quanto riguarda la gestione del carrello e il completamento dell'ordine.
                        </p>
                        <br></br>
                        <h5>
                            Modifiche alla Privacy e Cookie Policy
                        </h5>
                        <p>
                            Ci riserviamo il diritto di apportare modifiche alla presente Privacy e Cookie Policy. Gli utenti sono invitati a consultare periodicamente questa pagina per essere informati su eventuali cambiamenti.
                        </p>
                    </div>
                </div>


            </div>
        </div>
    );
}

export default Privacy